import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = apiMainUrl + 'ReportConfiguration'; // Adjust the URL based on your actual API's URL

// Fetch all reports
const getAllReports = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch reports:', error);
        throw error;
    }
};

// Fetch all selected reports
const getSelectedReports = async (token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/selected-reports`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch reports:', error);
        throw error;
    }
};

// Update report selections
const updateReports = async (reportSelections, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}`, reportSelections, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to update reports:', error);
        throw error;
    }
};

export const ReportsConfigurationDataService = {
    getAllReports,
    updateReports,
    getSelectedReports
};
